import React, { useContext } from "react";
import Footer from "components/Design/Footer/Footer";
import { DestinationCard } from "components/Design/Card";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import { useBreakpoint } from "gatsby-plugin-breakpoints";
import Icon from "components/CommonIcon/Icon";
import DESTINATION from "dictionaries/destinations";
import { embedLanguageInUrl } from "utils/embedLanguageInUrl";
import ConditionalLink from "components/ConditionalLink";
import {
  AYANA_LAKODIA,
  AYANA_JAKARTA_ID,
  AYANA_KOMODO_ID,
  AYANA_LAKODIA_ID,
} from "store/constants/hotel";
import { renderForMobile } from "utils/renderForMobile";
import { CRUISE_INQUIRY, GENERAL_INQUIRY } from "store/constants/support";
import { FooterLogo } from "components/Logo/AyanaLogo";
import PageContext from "contexts/PageContext";
import HOTELS from "dictionaries/hotelLink";
import { ArtDirectedImage } from "components/Design/ArtDirectedImage";
import { Link } from "gatsby-plugin-react-i18next";

const FooterSection = ({
  destinationCards,
  socialMedia,
  navigations,
  hotel,
  socialMediaLabel,
  lvxLogo,
}) => {
  const { t } = useTranslation("homepage");
  const breakpoints = useBreakpoint();
  const { language } = useI18next();
  const { location } = useContext(PageContext);

  const supportReason =
    hotel.name === AYANA_LAKODIA ? CRUISE_INQUIRY : GENERAL_INQUIRY;

  let logoLink = "";
  if (location) {
    logoLink = HOTELS[location];
  } else {
    logoLink = HOTELS[hotel.name];
  }
  logoLink ||= HOTELS[hotel.location];

  const destinations = destinationCards.map((destination, id) => {
    const destinationLink = DESTINATION[destination.title];
    const link = destinationLink.startsWith("https://")
      ? embedLanguageInUrl(destinationLink, language)
      : destinationLink;
    let returnData = {
      key: destination.id,
      name: destination.name,
      title: t(destination.title),
      to: link,
      image: renderForMobile(breakpoints)
        ? destination?.mobile
        : destination?.desktop,
    };
    return <DestinationCard {...returnData} />;
  });

  const socmedList = socialMedia?.socmed.map((socmed, id) => {
    return (
      <ConditionalLink
        link={socmed.link[language] || socmed.link["en"]}
        className="flex justify-center items-center">
        <Icon name={socmed.iconName} />
      </ConditionalLink>
    );
  });

  const menuItems = navigations?.menuItem.filter((f) =>
    f.navbar.includes("footer")
  );
  const menuList = menuItems
    ?.filter((f) => f.dropdownItems === false)
    .map((navigation, id) => {
      let returnData = {
        key: id,
        name: navigation.text,
        link: navigation.link?.startsWith("https://")
          ? embedLanguageInUrl(
            navigation.link,
            language,
            navigation.excludedLanguages || []
          )
          : navigation.link,
        newTab: navigation.newTab,
      };

      return returnData;
    });

  const otherMenuItems = menuItems?.filter((f) => f.dropdownItems === true);
  const otherMenuList = otherMenuItems?.map((menu) => {
    return (
      <ConditionalLink
        link={
          menu.link.startsWith("https://")
            ? embedLanguageInUrl(menu.link, language)
            : menu.link
        }
        supportReason={supportReason}
        className="ml-20">
        {t(menu.text)}
      </ConditionalLink>
    );
  });

  return (
    <Footer
      otherLogos={
        <div className="flex flex-col lg:flex-row items-center gap-28 lg:gap-40">
          {lvxLogo && (
            <a
              className="w-112"
              href="https://preferredhotels.com/hotels/indonesia/ayana-midplaza-jakarta">
              <ArtDirectedImage image={lvxLogo} />
            </a>
          )}
          <span className="ay-icon-ayana-footer-new text-black"></span>
          {(hotel.id === AYANA_LAKODIA_ID) && (
            <img
              src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/Logo_Earth_Check_0ab77e90d6.png"
              width={70}
              height={70}
            />
          )}
          {(hotel.id === AYANA_JAKARTA_ID) && (
            <img
              src="https://s3.ap-southeast-1.amazonaws.com/cms-staging.ayana.com/Earthcheck_Silver_Logo_8b63452adb.png"
              width={70}
              height={70}
            />
          )}
          {(hotel.id === AYANA_KOMODO_ID) && (
            <img
              src="https://s3.ap-southeast-1.amazonaws.com/cms-asset.ayana.com/Earth_Check_Silver_fee0a69838.jfif"
              width={70}
              height={70}
            />
          )}
        </div>
      }
      location={hotel.location}
      destinationCards={destinations}
      socialMedia={socmedList}
      menus={menuList}
      otherMenus={otherMenuList}
      socialMediaLabel={socialMediaLabel}
      multiLogo={Boolean(Array.isArray(hotel.logo))}
      propertyLogoDesktop={<FooterLogo hotel={hotel} />}
      propertyLogoMobile={<FooterLogo isMobile hotel={hotel} />}
      propertyUrl={logoLink}
    />
  );
};

export default FooterSection;
